<template>
  <section class="contact-section">
    <div class="contact-section-inner">
      <div class="contact-top">
        <div>
          <h2 class="contact-title">联系我们</h2>
          <p class="contact-intro">南京壹零壹陆信息科技有限公司，期待与您建立长期合作。</p>
        </div>
        <div class="contact-badge">1016</div>
      </div>
      <div class="contact-grid">
        <div class="contact-col">
          <h3 class="contact-col-title">公司信息</h3>
          <ul class="contact-info-list">
            <li>
              <span class="contact-info-label">公司名称</span>
              <span class="contact-info-value">南京壹零壹陆信息科技有限公司</span>
            </li>
            <li>
              <span class="contact-info-label">公司地址</span>
              <span class="contact-info-value">南京市栖霞区尧化街道上城风景北苑16幢1305-24-001室</span>
            </li>
            <li>
              <span class="contact-info-label">联系电话</span>
              <span class="contact-info-value">17768129723</span>
            </li>
            <li>
              <span class="contact-info-label">邮箱地址</span>
              <span class="contact-info-value">454520997@qq.com</span>
            </li>
            <li>
              <span class="contact-info-label">营业时间</span>
              <span class="contact-info-value">周一至周五 9:00-18:00</span>
            </li>
          </ul>
        </div>
        <div class="contact-col contact-col--consult">
          <h3 class="contact-col-title">业务咨询</h3>
          <p class="contact-consult-intro">
            如需了解产品或服务，欢迎联系我们的团队获取方案说明与合作支持。
          </p>
          <ul class="contact-consult-list">
            <li>产品方案咨询</li>
            <li>服务套餐说明</li>
            <li>合作洽谈</li>
            <li>售后支持</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactSection'
}
</script>

<style scoped>
.contact-section {
  background: linear-gradient(180deg, #e0f2fe 0%, #f4f8fc 100%);
  color: #1e293b;
  padding: 64px 20px 72px;
}

.contact-section-inner {
  max-width: 1120px;
  margin: 0 auto;
}

.contact-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 28px;
}

.contact-title {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #0284c7;
}

.contact-intro {
  font-size: 12px;
  color: #64748b;
  line-height: 1.6;
  max-width: 480px;
}

.contact-badge {
  min-width: 68px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #f43f5e;
  border: 1px solid #cfe0f0;
  border-radius: 16px;
  font-weight: 800;
  letter-spacing: 0.06em;
  box-shadow: 0 8px 20px rgba(2, 132, 199, 0.08);
}

.contact-grid {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 16px;
}

.contact-col {
  padding: 24px;
  background: #fff;
  border: 1px solid #dbe4f0;
  border-radius: 16px;
}

.contact-col--consult {
  background: #fff;
  border-color: #fecdd3;
}

.contact-col-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
  color: #0284c7;
}

.contact-col--consult .contact-col-title {
  color: #e11d48;
}

.contact-info-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-info-list li {
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr);
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
}

.contact-info-list li:last-child {
  border-bottom: none;
}

.contact-info-label {
  font-size: 13px;
  color: #94a3b8;
}

.contact-info-value {
  font-size: 14px;
  color: #1e293b;
  line-height: 1.6;
}

.contact-consult-intro {
  font-size: 14px;
  color: #64748b;
  line-height: 1.8;
  margin-bottom: 14px;
}

.contact-consult-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-consult-list li {
  position: relative;
  padding: 10px 0 10px 16px;
  border-bottom: 1px solid #ffe4e6;
  font-size: 14px;
  color: #334155;
}

.contact-consult-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 16px;
  width: 8px;
  height: 2px;
  background: #f43f5e;
}

@media (max-width: 768px) {
  .contact-top {
    flex-direction: column;
  }

  .contact-grid {
    grid-template-columns: 1fr;
  }

  .contact-info-list li {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}
</style>
